import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import OrcaSecurityConfigListing from './OrcaSecurityConfigListing'
import OrcaSecurityCredentialsForm from './OrcaSecurityCredentialsForm'

export default function OrcaSecurityPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={OrcaSecurityCredentialsForm}
            PullConfigListingView={OrcaSecurityConfigListing}
        />
    )
}